module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_1.6c5a83bb.jpg";